<template>
  <MlpMainLayout
    :msal-account="account"
    :base-url-config-file="baseUrlConfigFile"
    :should-intercom-be-init="!isTesting"
    :should-init-intercom-with-company="true"
    :user-company="currentUserCompany"
    @sign-out="signOut"
  >
    <RouterView />
  </MlpMainLayout>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import { useMsal } from '@/composables/auth/useMsal';
import { useCompanyStore } from '@/stores';

const { instance, account } = useMsal();
const { currentUserCompany } = storeToRefs(useCompanyStore());

const baseUrlConfigFile = import.meta.env.VITE_BASE_URL_CONFIG_FILE;
const isTesting = import.meta.env.VITE_FF_IS_TESTING === 'true';

const signOut = () => {
  instance.value.logoutRedirect();
};
</script>
